// ** React Imports
import { useCallback, useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useOpenGraphMetaTags from "hooks/useOpenGraphMetaTags";

// ** Utils & Helpers
import pseudoFormat from "utils/pseudoFormat";

// ** Custom Filters
import { compute as filterPreferencesCompute } from "hooks/filters/useFilterPreferences";

// ** Config
import configGlobal from "configuration";

// #####################################################

const useUsersMetaTags = ({ locationPathname, preferenceUrl }) => {
	const { t } = useTranslation("common", "filtersAndSelectors");

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const locationCountry = useSelector(
		(state) => state.mainPageUsers.location.country
	);
	const locationRegion = useSelector(
		(state) => state.mainPageUsers.location.region
	);
	const locationCity = useSelector(
		(state) => state.mainPageUsers.location.city
	);

	const totalUsersCountInCategory = useSelector(
		(state) => state.mainPageUsers.findnumber
	);

	// ** Preferencje
	const preferenceApiParam = useMemo(() => {
		return filterPreferencesCompute.urlToApiParam(preferenceUrl);
	}, [preferenceUrl]);

	const preferencesText = preferenceApiParam
		? `${t(`filtersAndSelectors:preferences.${preferenceApiParam}`)}`
		: undefined;

	// ** Nazwa Lokalizacji - Miasto lub Region lub Kraj
	const locationText = locationCity || locationRegion || locationCountry;

	// ** SEO TITLE
	const title = useMemo(() => {
		if (!isAuth) {
			return locationText
				? `${locationText} - Sex randki Datezone.com`
				: preferencesText
				? `${preferencesText} - Sex randki Datezone.com`
				: `${t("pages:users")} - Sex randki Datezone.com`;
		}
		return `${t("pages:users")} - Sex randki Datezone.com`;
	}, [locationText, preferencesText]);

	// ** SEO DESCRIPTION
	const metaDescription = useMemo(() => {
		return `Umawiaj się na sex spotkania albo znajdź partnera na dłużej. Poznaj ${
			locationText || preferencesText
				? pseudoFormat(totalUsersCountInCategory)
				: `1,0 mln`
		} realnych osób ${
			locationText
				? `z ${locationText}`
				: preferencesText
				? `które lubią ${preferencesText}`
				: "na Datezone"
		}. Wejdź i sprawdź za darmo!`;
	}, [locationText, preferencesText, totalUsersCountInCategory]);

	const link = `https://${configGlobal.host}${
		locationPathname.includes("undefined")
			? locationPathname.replace("/undefined", "")
			: locationPathname
	}`;
	const linkFinal = link.replace(/\/$/, "");

	// ** Open Graph Meta Tags
	const ogMetaTags = useOpenGraphMetaTags({
		customTitle: `${title} - ${t("common:titleTemplate")}`,
		customDescription: metaDescription,
		customUrl: linkFinal,
	});

	const canonicalLink = useCallback(() => {
		return <link rel="canonical" href={linkFinal} />;
	}, [locationPathname]);

	// #####################################################

	return {
		title,
		metaDescription: metaDescription,
		ogMetaTags,
		canonicalLink,
	};
};

// #####################################################

export default useUsersMetaTags;

// #####################################################
